import React from 'react';
import { isMobileScreen } from '@apply/ui';
import {
    Expander,
    ExpanderTheme,
    ExpanderButtonStyle,
    ExpanderBorderStyle,
    Panel,
    PanelTheme,
    PanelBorderStyle,
    PanelBorderRadius,
    renderCustomCountExpanderHeader,
} from '@apply/components';
import { IDashboardApplicationItem } from '@apply/api/src/api/ApplyApi';
import '../scss/_homepanels.scss';
import { formatDate } from '@apply/ui';

interface ApplyPendingApprovalParameters {
    applications: IDashboardApplicationItem[];
}

export const ApplyPendingApprovalPanel: React.FC<ApplyPendingApprovalParameters> = ({ applications }) => {
    const mobileScreen = isMobileScreen();

    return (
        <div style={{ marginTop: '20px', marginBottom: '20px' }}>
            <Expander
                header={renderCustomCountExpanderHeader(
                    applications.length,
                    `${!mobileScreen ? 'Apply Pending Approval' : 'Pending Approval'}`
                )}
                theme={ExpanderTheme.White}
                buttonStyle={ExpanderButtonStyle.Rounded}
                borderStyle={ExpanderBorderStyle.Rounded}
                initialExpanded={true}
            >
                {applications.map((application) => {
                    const addresses = application.properties.map((prop) => {
                        const { street1, street2, city } = prop;
                        return [street1, street2, city].filter(Boolean).join(', ');
                    });

                    return (
                        <div
                            key={application.applicationId}
                            style={{ marginLeft: '20px', marginRight: '20px' }}
                        >
                            <Panel
                                key={application.properties.map((prop) => prop.id).join('-')}
                                padding={10}
                                theme={PanelTheme.White}
                                borderRadius={PanelBorderRadius.Small}
                                borderStyle={PanelBorderStyle.Solid}
                            >
                                <div className='panelContent applyPending'>
                                    <div className='addressList'>
                                        {addresses.map((addr, i) => (
                                            <div
                                                key={i}
                                                className='addressItem'
                                            >
                                                {addr}
                                            </div>
                                        ))}
                                    </div>
                                    <div className='submittedDate'>Submitted: {formatDate(application.createdAt)}</div>
                                    <div className='missingFiles'>
                                        <Panel
                                            theme={PanelTheme.Red}
                                            padding={5}
                                            borderRadius={PanelBorderRadius.Medium}
                                        >
                                            Missing:{' '}
                                            <span className='missingFilesText'>{application.missingFiles.join(', ')}</span>
                                        </Panel>
                                    </div>
                                </div>
                            </Panel>
                        </div>
                    );
                })}
            </Expander>
        </div>
    );
};
